var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 8.5C10.067 8.5 8.5 10.067 8.5 12H7C7 9.23858 9.23858 7 12 7C13.5309 7 14.9012 7.68804 15.8183 8.77177L16 7.5H17L17 11H13.5V10L14.7406 9.82278C14.0993 9.01674 13.11 8.5 12 8.5ZM15.5 12C15.5 13.933 13.933 15.5 12 15.5C10.89 15.5 9.90065 14.9833 9.25944 14.1772L10.5 14V13L7 13L7 16.5H8L8.18168 15.2282C9.09885 16.312 10.4691 17 12 17C14.7614 17 17 14.7614 17 12H15.5Z",
    fill: "#030306",
    fillOpacity: 0.88
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplace);
export default __webpack_public_path__ + "static/media/replace.20b45f0dafd545c5655115ff0673d523.svg";
export { ForwardRef as ReactComponent };